import { MetadataPlugin } from "./metadata";
import { getGlobal } from "../lib/get-global";

type BraveNavigator = Navigator & {
  brave?: { isBrave?: () => Promise<boolean> };
};

/**
 * Detects if the users browser is brave and returns an object containing the boolean.
 * Return an empty object if Brave Brower isn't detected.
 */
export const createFeaturesPlugin: MetadataPlugin<number[] | undefined> =
  function () {
    async function getValue() {
      const globalThis = getGlobal();

      if (
        typeof globalThis === "undefined" ||
        typeof navigator === "undefined"
      ) {
        return {};
      }

      const nav = globalThis.navigator as BraveNavigator;

      if (
        typeof nav.brave === "object" &&
        typeof nav.brave.isBrave === "function"
      ) {
        const brave = await nav.brave.isBrave();
        if (brave) {
          return { features: [1] };
        }
      }

      return {};
    }

    return { getValue };
  };
